import { __assign, __rest } from "tslib";
import ScriptNext from 'next/script';
import React from 'react';
var Script = function (props) {
    var id = props.id, _a = props.strategy, strategy = _a === void 0 ? 'afterInteractive' : _a, src = props.src, htmlContent = props.htmlContent, _data = props.data, _manifest = props.manifest, _b = props.type, scriptType = _b === void 0 ? 'text/javascript' : _b, rest = __rest(props, ["id", "strategy", "src", "htmlContent", "data", "manifest", "type"]);
    var scriptTypeStrategy = strategy === 'worker' ? 'text/partytown' : scriptType;
    var nextStrategy = strategy === 'worker' ? undefined : strategy;
    return (React.createElement(ScriptNext, __assign({}, rest, { id: id, src: src, type: scriptTypeStrategy, strategy: nextStrategy, dangerouslySetInnerHTML: htmlContent ? { __html: htmlContent } : undefined })));
};
export default Script;
//# sourceMappingURL=Script.js.map